import { Check, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { getActionButtonClass } from "@/lib/semanticColors";
import { cn } from "@/lib/utils";

/**
 * A missing handler means the viewer lacks the grant for that action, so the
 * control is absent rather than present-and-inert. A disabled Approve button on
 * every row of the approval queue reads as a broken screen, not as a permission.
 */
export function ApprovalRequestRowActions({ invoice, onApprove, onReject }) {
  return (
    <div className="flex items-center justify-end gap-1">
      {onApprove && (
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              type="button"
              variant="outline"
              size="icon-sm"
              onClick={(event) => {
                event.stopPropagation();
                onApprove?.(invoice);
              }}
              title="Approve invoice"
              aria-label={`Approve invoice ${invoice.invoiceNumber}`}
              className={cn("table-row-action rounded-[0.8rem] shadow-none", getActionButtonClass("comment"))}
            />
          }
        >
          <Check className="size-3.5" />
        </TooltipTrigger>
        <TooltipContent>Approve</TooltipContent>
      </Tooltip>
      )}

      {onReject && (
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              type="button"
              variant="outline"
              size="icon-sm"
              onClick={(event) => {
                event.stopPropagation();
                onReject?.(invoice);
              }}
              title="Reject invoice"
              aria-label={`Reject invoice ${invoice.invoiceNumber}`}
              className={cn("table-row-action rounded-[0.8rem] shadow-none", getActionButtonClass("delete"))}
            />
          }
        >
          <X className="size-3.5" />
        </TooltipTrigger>
        <TooltipContent>Reject</TooltipContent>
      </Tooltip>
      )}
    </div>
  );
}
